
    <input nbInput placeholder="{{column.title}}" class="form-control" [formControl]="inputControl" [nbDatepicker]="rangepicker">
    <nb-rangepicker #rangepicker></nb-rangepicker>
  